import { render } from "./PoliticaView.vue?vue&type=template&id=7ae69096&scoped=true"
import script from "./PoliticaView.vue?vue&type=script&lang=js"
export * from "./PoliticaView.vue?vue&type=script&lang=js"

import "./PoliticaView.vue?vue&type=style&index=0&id=7ae69096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae69096"]])

export default __exports__